import Arena from './index';

export default {
    path: '/home/arena',
    component: Arena
};
